import { environment } from '../../environments/environment';

/**
 * Single source of truth for the API base URL.
 *
 * The value is resolved at BUILD TIME from the active Angular environment
 * file (`environment.ts` for dev, `environment.prod.ts` for prod via the
 * `fileReplacements` entry in angular.json).
 *
 * Intentionally contains NO origin sniffing, NO `localhost` checks, and NO
 * hardcoded domain fallback — the base URL comes exclusively from the
 * per-environment config.
 */
export const getApiBaseUrl = (): string => environment.apiBaseUrl;
